module.exports = __webpack_public_path__ + "static/media/webshop_splash_spare_parts.63b37726.png";